<template>
  <q-menu
      ref="menuRef"
      anchor="bottom right"
      self="top right"
      :offset="[0, 8]"
      transition-show="jump-down"
      transition-hide="jump-up"
  >
    <q-list style="min-width: 260px; width: 260px" class="q-pa-sm">
      <!-- Переключатель режима просмотра -->
      <q-item class="q-px-sm q-py-sm">
        <q-item-section>
          <q-btn-toggle
              :model-value="viewMode"
              :options="viewModeOptions"
              toggle-color="primary"
              color="grey-3"
              text-color="grey-8"
              unelevated
              spread
              no-wrap
              size="md"
              @update:model-value="onViewModeChange"
              class="view-mode-toggle"
          />
        </q-item-section>
      </q-item>

      <q-separator class="q-my-sm" />

      <!-- Сортировка -->
      <q-item class="q-px-sm">
        <q-item-section>
          <q-select
              :model-value="sortOption"
              :options="sortOptions"
              option-value="value"
              option-label="label"
              label="Сортировка"
              dense
              outlined
              emit-value
              map-options
              behavior="menu"
              @update:model-value="onSortChange"
              class="sort-select"
          >
            <template v-slot:prepend>
              <q-icon :name="ICONS.sort" size="xs" />
            </template>
          </q-select>
        </q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script setup lang="ts">
import { ICONS } from '@/assets/icons';
import { ref } from 'vue';

export interface ViewModeMenuProps {
  viewMode: 'grid' | 'list';
  sortOption: string;
  sortOptions?: Array<{ label: string; value: string }>;
}

const props = withDefaults(defineProps<ViewModeMenuProps>(), {
  sortOptions: () => [
    { label: 'Сначала дешевле', value: 'price_asc' },
    { label: 'Сначала дороже', value: 'price_desc' },
    { label: 'По популярности', value: 'popular' },
    { label: 'По имени', value: 'name_asc' },
  ]
});

const emit = defineEmits<{
  'update:viewMode': [value: 'grid' | 'list'];
  'update:sortOption': [value: string];
}>();

const menuRef = ref<any>(null);

const viewModeOptions = [
  { label: 'Сетка', value: 'grid', icon: ICONS.grid },
  { label: 'Список', value: 'list', icon: ICONS.list },
];

const onViewModeChange = (newMode: 'grid' | 'list') => {
  emit('update:viewMode', newMode);
  menuRef.value?.hide();
};

const onSortChange = (newSort: string) => {
  emit('update:sortOption', newSort);
  menuRef.value?.hide();
};

// Expose метод для закрытия меню извне
defineExpose({
  hide: () => menuRef.value?.hide()
});
</script>

<style lang="scss" scoped>
.view-mode-toggle {
  :deep(.q-btn__content) {
    font-size: 14px;
  }
}

.sort-select {
  :deep(.q-field__native),
  :deep(.q-field__label) {
    font-size: 12px;
  }
}
</style>
